import useLanguage from './useLanguage';

const useLocale = () => {
  const [language] = useLanguage();
  const locale = language.split('_')[0];
  return locale;
};

export default useLocale;
